import React from 'react'
import { CircularProgress, Paper, Stack } from '@mui/material'
import { Button, TextField, Typography } from '@mui/material'
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt'

import useLogin from '../hooks/useLogin'
import { useAuth } from '../../../providers'
import { useMobile } from '../../../hooks/useMoblie'

const PhoneNumberLogin = (props) => {
    const { setShowOtpVerification } = props
    const { error, status, handlePhoneNumberSubmit } = useLogin(setShowOtpVerification)
    const { phoneNumber, handlePhoneNumber } = useAuth()
    const isMobile = useMobile()
    return (
        <Paper
            sx={{
                width: isMobile ? 350 : 400,
                height: isMobile ? 350 : 400,
                p: 4,
                borderRadius: 8,
            }}
        >
            <Stack sx={{ mb: 2 }}>
                <Typography variant="h4">Log In</Typography>
                {/* <Typography variant="caption">Log In</Typography> */}
            </Stack>
            <Stack direction="row" alignItems="center">
                <Typography
                    align="left"
                    sx={(theme) => ({
                        backgroundColor: theme.palette.grey[300],
                        mr: 2,
                        p: 2,
                        fontSize: 18,
                        borderRadius: 1,
                    })}
                >
                    +91
                </Typography>
                <TextField
                    fullWidth
                    onChange={handlePhoneNumber}
                    variant="outlined"
                    value={phoneNumber}
                    label="Enter your phone number"
                    error={error ? true : false}
                    helperText={error}
                    inputProps={{
                        style: {
                            fontSize: '1rem',
                        },
                        maxLength: 10,
                        inputMode: 'numeric',
                    }}
                    autoFocus
                    required
                />
            </Stack>

            <Button
                fullWidth
                sx={{
                    mt: 4,
                    height: 48,
                }}
                onClick={handlePhoneNumberSubmit}
                variant="contained"
                endIcon={status !== 'loading' && <ArrowRightAltIcon />}
                disabled={status === 'loading'}
            >
                {status === 'loading' ? <CircularProgress size={30} /> : `Login to Book Worker`}
            </Button>
        </Paper>
    )
}

export default PhoneNumberLogin
